// Currency utility for GBP formatting
export const formatGBP = (amount) => {
  if (amount === null || amount === undefined) return '£0.00';
  
  // Convert to number if it's a string
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  // Handle cents (amounts stored as pence)
  const pounds = numAmount / 100;
  
  return `£${pounds.toFixed(2)}`;
};

export const formatGBPFromPounds = (pounds) => {
  if (pounds === null || pounds === undefined) return '£0.00';
  
  const numPounds = typeof pounds === 'string' ? parseFloat(pounds) : pounds;
  
  return `£${numPounds.toFixed(2)}`;
};

// Currency symbol constant
export const CURRENCY_SYMBOL = '£';
export const CURRENCY_CODE = 'GBP'; 